import React from 'react';
import {
  string,
} from 'prop-types';
import { Heading, Paragraph, Icon } from 'components/common/';
import './ContactInfo.scss';

const ContactInfo = ({
  title, officeHours, tel, content, address, number,
}) => (
  <div className="contact-info">
    <div className="contact-info__row">
      <div className="contact-info__content">
        <Heading as="h2">
          {title}
        </Heading>
        <Paragraph>
          {officeHours}
        </Paragraph>
        {tel && (
          <a href={`tel:${number}`}>
            <Heading primary as="h2">
              <Icon name="phone" primary medium className="contact-info__icon" />
              {tel}
            </Heading>
          </a>
        )}
        <div className="contact-info--2nd-paragraph">
          <Paragraph secondary>
            {content}
          </Paragraph>
        </div>
        <Paragraph>
          {address}
        </Paragraph>
      </div>
    </div>
  </div>
);

ContactInfo.defaultProps = {
  title: 'Contact Us',
  officeHours: 'Mon-Fri 9:30am-7:00pm',
  tel: '',
  content: "If you'd like to talk to someone right away, simply give us a call - we're here for you!",
  address: '21/F, 88 Hing Fat Street, Causeway Bay, Hong Kong',
  number: '',
};

ContactInfo.propTypes = {
  title: string,
  officeHours: string,
  tel: string,
  content: string,
  address: string,
  number: string,
};

export default ContactInfo;

